module.exports = __webpack_public_path__ + "img/Facebook Logo.abf5e01f.png";